import { useState, useContext } from "preact/hooks";
import useLocalStorageState from "use-local-storage-state";
import { useMutation } from "@apollo/client";
import { GlobalContext } from "@/context/GlobalContext";

import useSnackBar from "@/hooks/useSnackBar";
import ADD_TO_CART_MUTATION from "@/mutations/addToCart";

function useWishList() {
	const [wishListTotal, setWishlistTotal] = useState(0);
	const [retailerObj, setRetailerObj] = useLocalStorageState("dutchie_retailer");
	const wishlistKey = `cp_dutchie_wishlist__${retailerObj?.id}`;
	const [wishList, setWishList] = useLocalStorageState(wishlistKey, {
		defaultValue: [],
	});
	const {handleOpen} = useSnackBar();
	const {sideCartOpen, setSideCartOpen} = useContext(GlobalContext);
	const [retailerObject, setRetailerObject] = useLocalStorageState("dutchie_retailer");
	const retailerId = retailerObject?.id;
	const retailerSlug = retailerObject?.slug;
	const {checkout, setCheckout} = useContext(GlobalContext);
	const [checkoutId, setCheckoutId] = useLocalStorageState(
		"dutchie_checkout_" + retailerSlug
	);

	function addToWishlist(product) {
		if (wishList && wishList.find((item) => item === product.id)) {
			return;
		}

		//add to the beginning of the array
		setWishList([product, ...wishList]);
	}

	function removeFromWishlist(product) {
		setWishList(wishList.filter((item) => item.id !== product.id));
	}

	function isInWishlist(product) {
		return wishList && wishList.find((item) => item.id === product.id);
	}

	const [addToCart, { addToCartloading, addToCartError }] = useMutation(ADD_TO_CART_MUTATION, {
		onCompleted(data) {
			setSideCartOpen(true);
		},
		onError(error) {
			console.log(error);
			handleOpen(error.message);
		},
	});

	const addAllItemsToCart = async () => {
		const addAll = await Promise.all(
			wishList.map((product) => {
				return addToCart({
					variables: {
						retailerId: retailerId,
						checkoutId: checkoutId,
						productId: product.id,
						quantity: 1,
						option: product.variants[0].option,
					},
				});
			})
		);
		return addAll;
	};

	const buyAllItemsNow = async () => {
		await addAllItemsToCart();
		window.location.href = `${checkout.redirectUrl}?r=${dutchie.order_confirmed_page_url}`;
	};

	const calculateTotalPrice = () => {
		let totalPrice = 0;
		wishList.forEach((product) => {
			const price = product.variants[0].priceRec;
			totalPrice += price;
		});

		totalPrice = new Intl.NumberFormat("en-US", {
			style: "currency",
			currency: "USD",
		}).format(totalPrice);
		
		return totalPrice;
	};

	return {
		wishList,
		addToWishlist,
		removeFromWishlist,
		isInWishlist,
		addAllItemsToCart,
		buyAllItemsNow,
		calculateTotalPrice,
	};
}
export default useWishList;